import { Box } from '@mui/material'
import UserChatBubbleReactionsBar from './UserChatBubbleReactionsBar'

export default function UserChatBubbleHoverAnchor({
  bubbleWithReactionsClassName,
  bubbleAnchorRef,
  bubbleAnchorClassName,
  bubbleZoneEnter,
  bubbleZoneLeave,
  morphBubble,
  reactions,
  bubbleAlign,
  onReaction,
  reactionPickerAnchorEl,
  setReactionPickerAnchorEl,
  setMoreMenuAnchor,
}) {
  return (
    <Box className={bubbleWithReactionsClassName}>
      <Box
        ref={bubbleAnchorRef}
        className={bubbleAnchorClassName}
        onMouseEnter={bubbleZoneEnter}
        onMouseLeave={bubbleZoneLeave}
      >
        {morphBubble}
      </Box>
      <UserChatBubbleReactionsBar
        reactions={reactions}
        bubbleAlign={bubbleAlign}
        onReaction={onReaction}
        reactionPickerAnchorEl={reactionPickerAnchorEl}
        setReactionPickerAnchorEl={setReactionPickerAnchorEl}
        setMoreMenuAnchor={setMoreMenuAnchor}
      />
    </Box>
  )
}
